const channelKey = 'lq-csfupinti';
const channel = new BroadcastChannel(channelKey);
import { electronCloseTab, isElectron } from '@/utils/electron';
channel.onmessage = (event) => {
	if (['logout', 'login'].includes(event.data.type)) {
		if (event.data.type === 'logout') {
			window.name = '';
			closeSubTab();
			if (window.opener && window.opener.location.origin === window.location.origin) {
				window.opener.focus();
				window.close();
			}
		}
		window.location.reload();
	}
};

export const reloadChannel = (type: string) => {
	channel.postMessage({ type });
	if (type === 'logout') {
		window.name = '';
		closeSubTab();
		if (window.opener && window.opener.location.origin === window.location.origin) {
			window.opener.focus();
			window.close();
		}
		window.location.reload();
	}
};

function closeSubTab() {
	if (isElectron()) {
		electronCloseTab(window.location.origin + '/invoice.html');
		electronCloseTab('http://111.9.8.241:31215?date=');
		electronCloseTab('https://cloud.lqzhcs.com.cn/financial/');
		electronCloseTab('https://www.lqzhcs.com.cn/financial/');
	} else {
		if (window.financialTab && !window.financialTab.closed) {
			window.financialTab.close();
		}
	}
}
export default channel;
